import { render, staticRenderFns } from "../../templates/form/bull-form.pug?vue&type=template&id=10353730&lang=pug&"
import script from "./BullForm.vue?vue&type=script&lang=js&"
export * from "./BullForm.vue?vue&type=script&lang=js&"
import style0 from "./BullForm.vue?vue&type=style&index=0&id=10353730&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports